import Rellax from 'rellax';

export const parallax = () => {
  const $els = $('.wp-block-cover.has-parallax');

  if ($els.length) {
    $els.each(function () {
      $(this).prepend('<div class="custom-parallax">');
    });

    new Rellax('.custom-parallax', {
      speed: 3,
      center: true,
    });
  }

  const $shiftUp = $('.rellax.up');

  if ($shiftUp.length > 0) {
    $shiftUp.each((_, el) => {
      new Rellax(el, {
        speed: 2,
        center: true,
        callback() {
          // scale images
          const topOffset = el.getBoundingClientRect().top;
          const parentHeight = el.clientHeight;

          const visiblePercentage =
            topOffset > 0 ? (parentHeight + topOffset) / parentHeight : 1;

          const scale = 1 + visiblePercentage * 0.08;

          $(el)
            .closest('.wp-block-media-text')
            .find('.wp-block-media-text__media img')
            .each((_, img) => {
              $(img).css('transform', 'scale(' + scale + ')');
            });
        },
      });
    });
  }
};
